import React, { useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";

import Preloader from "../../helper/Preloader";
import ColorInit from "../../helper/ColorInit";
import HeaderOne from "../../components/layout/HeaderOne";
import Breadcrumb from "../../components/layout/Breadcrumb";
import FooterOne from "../../components/layout/FooterOne";
import BottomFooter from "../../components/layout/BottomFooter";
import Checkout from "../../components/account/Checkout";
import SelectAddress from "../../components/SelectAddress";
import ScrollToTop from "react-scroll-to-top";
import AddNewAddress from "../../components/AddNewAddress";
import OrderDetail from "../../components/account/OrderDetail";

const OrderDetailPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state; // { id: 1, name: "Eka", role: "Frontend Dev" }
  const [addressEnum, setAddressEnum] = React.useState(0);

  const handleAddressEnumChange = (add) => {
    navigate(`/account?t=order`);
  };

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#990A02" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderOne />

      {/* Breadcrumb */}
      <Breadcrumb
        title={"Order Details"}
        addressEnumChange={handleAddressEnumChange}
        isChildren={true}
      />

      {/* Order Detail */}
      <OrderDetail dataInvoice={data} />

      {/* FooterTwo */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default OrderDetailPage;
